var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogisticsFlatline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "logistics-flatline",
    imageName: "Logistics",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_64_logistics",
    "data-name": "#64_logistics"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.77,241.48H47.23a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H352.77a.5.5,0,0,1,.5.5A.5.5,0,0,1,352.77,241.48Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.54,
    y: 168.62,
    width: 56.83,
    height: 72.36,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.38,241.48H234.54a.5.5,0,0,1-.5-.5V168.62a.5.5,0,0,1,.5-.5h56.84a.5.5,0,0,1,.5.5V241A.5.5,0,0,1,291.38,241.48Zm-56.34-1h55.84V169.12H235Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.9,
    y: 173.56,
    width: 46.12,
    height: 62.47,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,236.53H239.9a.5.5,0,0,1-.5-.5V173.56a.5.5,0,0,1,.5-.5H286a.5.5,0,0,1,.5.5V236A.5.5,0,0,1,286,236.53Zm-45.62-1h45.12V174.06H240.4Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.02 230.04 286.02 236.03 282.24 236.03 262.04 209.43 257.9 204.01 239.9 180.31 239.9 173.56 243.03 173.56 262.04 198.55 266.17 204.01 286.02 230.04",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,236.53h-3.78a.47.47,0,0,1-.39-.2L239.5,180.61a.54.54,0,0,1-.1-.3v-6.75a.5.5,0,0,1,.5-.5H243a.5.5,0,0,1,.4.19l23.14,30.46,19.85,26a.54.54,0,0,1,.1.3v6A.5.5,0,0,1,286,236.53Zm-3.53-1h3v-5.32l-23.88-31.36-18.86-24.79H240.4v6.08Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.02 173.56 286.02 177.94 266.17 204.01 262.04 209.43 241.83 236.03 239.9 236.03 239.9 227.67 257.9 204.01 262.04 198.55 281.08 173.56 286.02 173.56",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.83,236.53H239.9a.5.5,0,0,1-.5-.5v-8.36a.54.54,0,0,1,.1-.3l41.18-54.12a.51.51,0,0,1,.4-.19H286a.5.5,0,0,1,.5.5v4.38a.54.54,0,0,1-.1.3l-44.19,58.09A.51.51,0,0,1,241.83,236.53Zm-1.43-1h1.18l43.94-57.76v-3.71h-4.19L240.4,227.84Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.43,
    y: 168.62,
    width: 71.11,
    height: 72.36,
    transform: "translate(397.98 409.6) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.54,241.48H163.43a.5.5,0,0,1-.5-.5V168.62a.5.5,0,0,1,.5-.5h71.11a.5.5,0,0,1,.5.5V241A.5.5,0,0,1,234.54,241.48Zm-70.61-1H234V169.12H163.93Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.58,
    y: 173.56,
    width: 60.81,
    height: 62.47,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,236.53H168.58a.5.5,0,0,1-.5-.5V173.56a.5.5,0,0,1,.5-.5h60.81a.5.5,0,0,1,.5.5V236A.5.5,0,0,1,229.39,236.53Zm-60.31-1h59.81V174.06H169.08Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.59 230.04 168.59 236.03 173.56 236.03 200.21 209.43 205.66 204.01 229.39 180.31 229.39 173.56 225.26 173.56 200.21 198.55 194.75 204.01 168.59 230.04",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,236.53h-5a.5.5,0,0,1-.5-.5v-6a.51.51,0,0,1,.15-.35l31.62-31.5,25.06-25a.5.5,0,0,1,.35-.14h4.13a.5.5,0,0,1,.5.5v6.75a.5.5,0,0,1-.14.35l-55.83,55.72A.49.49,0,0,1,173.56,236.53Zm-4.48-1h4.28l55.53-55.43v-6h-3.42l-30.36,30.3-26,25.89Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.59 173.56 168.59 177.94 194.75 204.01 200.21 209.43 226.85 236.03 229.39 236.03 229.39 227.67 205.66 204.01 200.21 198.55 175.1 173.56 168.59 173.56",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,236.53h-2.54a.47.47,0,0,1-.35-.15l-32.1-32-26.17-26.07a.51.51,0,0,1-.15-.35v-4.38a.5.5,0,0,1,.5-.5h6.52a.5.5,0,0,1,.35.14L206,203.66l23.73,23.66a.5.5,0,0,1,.14.35V236A.5.5,0,0,1,229.39,236.53Zm-2.33-1h1.83v-7.65l-29-29-25-24.84h-5.81v3.67l31.48,31.35Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.03,
    y: 96.25,
    width: 56.83,
    height: 72.36,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87,169.12H262a.5.5,0,0,1-.5-.5V96.25a.51.51,0,0,1,.5-.5h56.84a.51.51,0,0,1,.5.5v72.37A.5.5,0,0,1,318.87,169.12Zm-56.34-1h55.84V96.75H262.53Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.39,
    y: 101.19,
    width: 46.12,
    height: 62.47,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.51,164.17H267.39a.5.5,0,0,1-.5-.5V101.19a.5.5,0,0,1,.5-.5h46.12a.5.5,0,0,1,.5.5v62.48A.5.5,0,0,1,313.51,164.17Zm-45.62-1H313V101.69H267.89Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.51 157.68 313.51 163.66 309.73 163.66 289.53 137.07 285.39 131.65 267.39 107.94 267.39 101.19 270.52 101.19 289.53 126.18 293.66 131.65 313.51 157.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.51,164.17h-3.78a.5.5,0,0,1-.39-.2L267,108.24a.51.51,0,0,1-.1-.3v-6.75a.5.5,0,0,1,.5-.5h3.13a.51.51,0,0,1,.4.2l23.14,30.45,19.85,26a.51.51,0,0,1,.1.3v6A.5.5,0,0,1,313.51,164.17Zm-3.53-1h3v-5.32l-23.88-31.37-18.86-24.79h-2.38v6.08Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.51 101.19 313.51 105.57 293.66 131.65 289.53 137.07 269.32 163.66 267.39 163.66 267.39 155.31 285.39 131.65 289.53 126.18 308.57 101.19 313.51 101.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.32,164.17h-1.93a.5.5,0,0,1-.5-.5v-8.36a.51.51,0,0,1,.1-.3l41.18-54.12a.52.52,0,0,1,.4-.2h4.94a.5.5,0,0,1,.5.5v4.38a.51.51,0,0,1-.1.3L269.72,164A.54.54,0,0,1,269.32,164.17Zm-1.43-1h1.18L313,105.4v-3.71h-4.19l-40.93,53.79Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.92,
    y: 96.25,
    width: 71.11,
    height: 72.36,
    transform: "translate(452.96 264.87) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,169.12H190.92a.5.5,0,0,1-.5-.5V96.25a.51.51,0,0,1,.5-.5H262a.5.5,0,0,1,.5.5v72.37A.5.5,0,0,1,262,169.12Zm-70.61-1h70.11V96.75H191.42Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.07,
    y: 101.19,
    width: 60.81,
    height: 62.47,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,164.17h-60.8a.5.5,0,0,1-.5-.5V101.19a.5.5,0,0,1,.5-.5h60.8a.5.5,0,0,1,.5.5v62.48A.5.5,0,0,1,256.88,164.17Zm-60.3-1h59.8V101.69h-59.8Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 157.68 196.07 163.66 201.05 163.66 227.7 137.07 233.15 131.65 256.88 107.94 256.88 101.19 252.75 101.19 227.7 126.18 222.24 131.65 196.07 157.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.05,164.17h-5a.5.5,0,0,1-.5-.5v-6a.54.54,0,0,1,.14-.36l31.62-31.49,25.06-25a.51.51,0,0,1,.35-.15h4.13a.5.5,0,0,1,.5.5v6.75a.54.54,0,0,1-.14.36L201.41,164A.53.53,0,0,1,201.05,164.17Zm-4.47-1h4.27l55.53-55.44v-6H253L222.6,132l-26,25.89Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 101.19 196.07 105.57 222.24 131.65 227.7 137.07 254.34 163.66 256.88 163.66 256.88 155.31 233.15 131.65 227.7 126.18 202.59 101.19 196.07 101.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,164.17h-2.54A.51.51,0,0,1,254,164l-32.1-32-26.17-26.07a.54.54,0,0,1-.14-.36v-4.38a.5.5,0,0,1,.5-.5h6.51a.47.47,0,0,1,.35.15l30.57,30.45L257.24,155a.54.54,0,0,1,.14.36v8.36A.5.5,0,0,1,256.88,164.17Zm-2.33-1h1.83v-7.65l-29-29-25-24.85h-5.8v3.67l31.47,31.35Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.38,
    y: 168.62,
    width: 56.83,
    height: 72.36,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.21,241.48H291.38a.5.5,0,0,1-.5-.5V168.62a.5.5,0,0,1,.5-.5h56.83a.5.5,0,0,1,.5.5V241A.5.5,0,0,1,348.21,241.48Zm-56.33-1h55.83V169.12H291.88Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.73,
    y: 173.56,
    width: 46.12,
    height: 62.47,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.85,236.53H296.73a.5.5,0,0,1-.5-.5V173.56a.5.5,0,0,1,.5-.5h46.12a.5.5,0,0,1,.5.5V236A.5.5,0,0,1,342.85,236.53Zm-45.62-1h45.12V174.06H297.23Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.85 230.04 342.85 236.03 339.08 236.03 318.87 209.43 314.73 204.01 296.73 180.31 296.73 173.56 299.87 173.56 318.87 198.55 323.01 204.01 342.85 230.04",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.85,236.53h-3.77a.48.48,0,0,1-.4-.2l-42.35-55.72a.54.54,0,0,1-.1-.3v-6.75a.5.5,0,0,1,.5-.5h3.14a.49.49,0,0,1,.39.19l23.15,30.46,19.84,26a.47.47,0,0,1,.1.3v6A.5.5,0,0,1,342.85,236.53Zm-3.52-1h3v-5.32l-23.88-31.36-18.85-24.79h-2.39v6.08Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.85 173.56 342.85 177.94 323.01 204.01 318.87 209.43 298.66 236.03 296.73 236.03 296.73 227.67 314.73 204.01 318.87 198.55 337.91 173.56 342.85 173.56",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.66,236.53h-1.93a.5.5,0,0,1-.5-.5v-8.36a.54.54,0,0,1,.1-.3l41.18-54.12a.53.53,0,0,1,.4-.19h4.94a.5.5,0,0,1,.5.5v4.38a.47.47,0,0,1-.1.3l-44.19,58.09A.49.49,0,0,1,298.66,236.53Zm-1.43-1h1.18l43.94-57.76v-3.71h-4.19l-40.93,53.78Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.63,
    y: 181.49,
    width: 19.83,
    height: 16.87,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.46,198.86H244.63a.5.5,0,0,1-.5-.5V181.49a.5.5,0,0,1,.5-.5h19.83a.5.5,0,0,1,.5.5v16.87A.5.5,0,0,1,264.46,198.86Zm-19.33-1H264V182H245.13Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,186.17H248a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5A.51.51,0,0,1,261.07,186.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,190.43H248a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5A.51.51,0,0,1,261.07,190.43Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.76,194.69H248a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h8.74a.5.5,0,0,1,.5.5A.51.51,0,0,1,256.76,194.69Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 181.49,
    width: 19.83,
    height: 16.87,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.42,198.86H303.6a.5.5,0,0,1-.5-.5V181.49a.5.5,0,0,1,.5-.5h19.82a.5.5,0,0,1,.5.5v16.87A.5.5,0,0,1,323.42,198.86Zm-19.32-1h18.82V182H304.1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,186.17H307a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5A.5.5,0,0,1,320,186.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,190.43H307a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5A.5.5,0,0,1,320,190.43Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.72,194.69H307a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h8.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,315.72,194.69Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.02,
    y: 108.05,
    width: 19.83,
    height: 16.87,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.85,125.42H274a.5.5,0,0,1-.5-.5V108.05a.5.5,0,0,1,.5-.5h19.83a.5.5,0,0,1,.5.5v16.87A.5.5,0,0,1,293.85,125.42Zm-19.33-1h18.83V108.55H274.52Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.46,112.72h-13a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h13a.51.51,0,0,1,.5.5A.5.5,0,0,1,290.46,112.72Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.46,117h-13a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h13a.51.51,0,0,1,.5.5A.5.5,0,0,1,290.46,117Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.15,121.25h-8.74a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h8.74a.5.5,0,0,1,.5.5A.51.51,0,0,1,286.15,121.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,79.74s-36.06,53.79-35.29,54.35,17.64,7.47,17.64,7.47L90.77,121Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.55,142.06a.65.65,0,0,1-.19,0c-2.83-1.16-17-7-17.74-7.53-.58-.42-.87-.63,17.23-28.06,8.82-13.36,17.85-26.83,17.94-27a.5.5,0,0,1,.91.23L91.26,121a.47.47,0,0,1-.15.4L69.9,141.92A.52.52,0,0,1,69.55,142.06Zm-17-8.22c1.81.88,10.75,4.59,16.94,7.13l20.81-20.14L86.83,81.2C73.4,101.24,54.18,130.31,52.5,133.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,80.05,168,119.43s-5.26,12.66-11.57,11.14S134.65,96,134.65,96Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,131.19a4.89,4.89,0,0,1-1.19-.14c-6.47-1.57-21.52-33.53-22.15-34.89a.46.46,0,0,1,0-.48l10.25-15.9a.5.5,0,0,1,.42-.23h0a.49.49,0,0,1,.41.25l23.15,39.38a.49.49,0,0,1,0,.44C168.29,120.12,163.61,131.19,157.54,131.19ZM135.21,96c4.39,9.32,16.43,32.9,21.37,34.09,5.38,1.3,10.16-9,10.9-10.62L144.88,81Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.9 134.09 84.49 245.91 99.76 245.91 113.42 166.16 121.03 244.51 136.64 244.51 137.15 141.56 88.9 134.09",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.76,246.41H84.49a.5.5,0,0,1-.5-.52L88.4,134.07a.51.51,0,0,1,.18-.37.52.52,0,0,1,.4-.11l48.24,7.48a.49.49,0,0,1,.43.49l-.51,103a.51.51,0,0,1-.5.49H121a.5.5,0,0,1-.5-.45l-7.25-74.64-13,76.09A.5.5,0,0,1,99.76,246.41Zm-14.75-1H99.34l13.58-79.33a.5.5,0,0,1,1,0l7.57,77.9h14.66l.51-102-47.27-7.32Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.12,228.33c1.77.26,12.13,2.29,12.93,0a6.49,6.49,0,0,1,2.58-3.31h6.62l-3.05,31.06s14.51,8.91,14.51,10.43S127.19,263,127.19,263l-.56,2.42-4.32-.51Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,228.33c-1.77.26-12.13,2.29-12.93,0A6.49,6.49,0,0,0,88,225H81.33l3,31.06s-14.5,8.91-14.5,10.43S94.39,263,94.39,263l.56,2.42,4.32-.51Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,76.91s-29.66-3-35.43,1.72-8.15,67-8.15,67l49.55,1.83S141.61,87.38,130.78,76.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.75,148h0l-49.55-1.83a.54.54,0,0,1-.34-.16.49.49,0,0,1-.13-.36c.09-2.55,2.45-62.59,8.32-67.4s34.58-2,35.8-1.84a.49.49,0,0,1,.3.14c4.59,4.44,7,17.75,7.19,39.57.14,16.18-1.06,31.27-1.07,31.42A.5.5,0,0,1,136.75,148Zm-49-2.81L136.29,147c.42-5.65,4.15-59.57-5.73-69.59-2.45-.24-29.57-2.72-34.9,1.63C91.12,82.74,88.41,127.56,87.72,145.19Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14,110.39h0a.51.51,0,0,1-.45-.33c-1.74-4.71-10.38-28.31-9.41-30.52a.51.51,0,0,1,.66-.25.5.5,0,0,1,.26.65c-.49,1.39,4.2,15.55,9,28.6,1.73-4.06,7.47-18,9-26.75a.51.51,0,0,1,.58-.41.5.5,0,0,1,.4.58c-1.76,10.38-9.43,28-9.51,28.13A.49.49,0,0,1,114.14,110.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.29,75.17l-1,22.87-.26,6.3-.36,8.79-.26,6.3-.81,19.76-23.24-1s.17-8.48.58-19c.08-2,.17-4.16.27-6.31.14-2.91.29-5.88.46-8.78.13-2.15.27-4.27.43-6.3.64-8.52,1.49-15.67,2.61-18C88.16,72.57,106.29,75.17,106.29,75.17Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.49,104.86c0,2.9-.08,5.85-.15,8.78-.05,2.14-.11,4.25-.17,6.3-.38,11.83-.93,21.62-.93,21.62l-23.15-1.87.4-20,.13-6.31.17-8.78.13-6.3.46-22.77s18.13-2.59,21.52,4.56c1.1,2.33,1.52,9.67,1.6,18.5C146.5,100.59,146.5,102.7,146.49,104.86Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.77,158.35a.52.52,0,0,1-.46-.29.5.5,0,0,1,.25-.66,12.67,12.67,0,0,0,7-8.63.51.51,0,0,1,.57-.41.5.5,0,0,1,.41.58A13.4,13.4,0,0,1,91,158.3.46.46,0,0,1,90.77,158.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,158.35a.51.51,0,0,1-.31-.11,11.86,11.86,0,0,1-4.25-9.42.5.5,0,0,1,1,.07,11.09,11.09,0,0,0,3.89,8.57.5.5,0,0,1-.32.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,164.79h0a.49.49,0,0,1-.49-.49c0-.52.81-14.86.85-15.47a.47.47,0,0,1,.52-.47.49.49,0,0,1,.47.52c-.23,4.15-.85,15-.85,15.42A.49.49,0,0,1,113.33,164.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.75,148h0l-49.55-1.83a.5.5,0,0,1,0-1h0L136.77,147a.5.5,0,0,1,0,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.15,97.75l23.19.29-.26,6.3-23.36-.29C81.85,101.9,82,99.78,82.15,97.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.49,104.86l-23.7-.3.13-6.3,23.58.29C146.5,100.59,146.5,102.7,146.49,104.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.26,112.83l23.46.3-.26,6.3L81,119.14C81.07,117.1,81.16,115,81.26,112.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.34,113.64c-.05,2.14-.11,4.25-.17,6.3l-23.68-.29.13-6.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.91,58.41c-.18-.37,1.6-4.54,1-11.12s-12.69-8.9-17-8.34-8.71,5-9.61,9.38,1,12.17,1,12.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28,61a.51.51,0,0,1-.5-.39c-.08-.32-1.92-8-1-12.39,1-4.73,5.57-9.22,10-9.79,3-.39,10.57.61,14.77,4a6.93,6.93,0,0,1,2.85,4.81,29.77,29.77,0,0,1-.84,10.25c-.08.34-.16.69-.17.82a.57.57,0,0,1-.06.36.53.53,0,0,1-.41.26L103.32,61Zm10-21.62a11.72,11.72,0,0,0-1.39.07c-4,.52-8.28,4.71-9.16,9-.74,3.62.53,9.83.9,11.52l23.75-2c0-.18.09-.4.16-.69a28.68,28.68,0,0,0,.81-9.92,5.92,5.92,0,0,0-2.46-4.09C122.75,40.67,116.92,39.39,113.33,39.39Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26,58c.67-4.19,7.63-5.23,7.29-.29a7.31,7.31,0,0,1-1.86,4.64A4.3,4.3,0,0,1,125,63.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.47,64.28a4,4,0,0,1-1.66-.35.52.52,0,0,1-.26-.68.53.53,0,0,1,.69-.26,3.81,3.81,0,0,0,4.08-1A6.84,6.84,0,0,0,131,57.7c.11-1.58-.62-2.57-2-2.73a4,4,0,0,0-4.26,3.13.52.52,0,0,1-.59.43.52.52,0,0,1-.43-.59,5,5,0,0,1,5.4-4,3.24,3.24,0,0,1,2.91,3.82,7.81,7.81,0,0,1-2,5A5.11,5.11,0,0,1,126.47,64.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,58c-.67-4.19-7.63-5.23-7.28-.29a7.24,7.24,0,0,0,1.85,4.64,4.3,4.3,0,0,0,4.66,1.09",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,64.28a5.11,5.11,0,0,1-3.59-1.55,7.83,7.83,0,0,1-2-5A3.24,3.24,0,0,1,102,54a5,5,0,0,1,5.4,4,.52.52,0,0,1-.43.59.52.52,0,0,1-.59-.43A4,4,0,0,0,102.16,55c-1.38.16-2.11,1.15-2,2.73A6.84,6.84,0,0,0,101.87,62,3.81,3.81,0,0,0,106,63a.53.53,0,0,1,.69.26.52.52,0,0,1-.26.68A4,4,0,0,1,104.72,64.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,77.09s2.49,6,8,6a8.87,8.87,0,0,0,7.72-4.1L122.4,76l-.54-6.81-.51-6.37H108.82l-.42,5.21-.13,1.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.91,83.57c-5.77,0-8.35-6-8.46-6.28a.49.49,0,0,1,0-.29l1.34-7.35.54-6.84a.51.51,0,0,1,.52-.47h12.53a.5.5,0,0,1,.51.47l1.28,16.11a.45.45,0,0,1-.06.28A9.31,9.31,0,0,1,114.91,83.57ZM107.46,77c.41.86,2.82,5.52,7.45,5.52a8.31,8.31,0,0,0,7.19-3.71l-1.23-15.46H109.29l-.51,6.42Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,67.58a6,6,0,0,0,.85,2.17,11.15,11.15,0,0,0,4.12,3.6c2.7,1.5,6.73,3.18,10,2.68l-.54-6.81a30.61,30.61,0,0,1-7.23,0,20.74,20.74,0,0,1-6.23-1.2C108.06,67.91,107.74,67.75,107.42,67.58Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,76.61c-3.35,0-7-1.71-9-2.82a11.5,11.5,0,0,1-4.3-3.78,6.45,6.45,0,0,1-.92-2.35.5.5,0,0,1,.21-.49.51.51,0,0,1,.53,0,10,10,0,0,0,.93.46,20.4,20.4,0,0,0,6.08,1.17,29.69,29.69,0,0,0,7.11,0,.52.52,0,0,1,.38.11.47.47,0,0,1,.18.35l.54,6.81a.49.49,0,0,1-.42.53A9.54,9.54,0,0,1,121.15,76.61Zm-13-8.1a5.19,5.19,0,0,0,.49,1,10.45,10.45,0,0,0,3.94,3.44c2.07,1.14,6,3,9.23,2.67l-.46-5.81a32.24,32.24,0,0,1-6.81,0,21.27,21.27,0,0,1-6.38-1.24Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.72,70.82h1.12a9.6,9.6,0,0,0,9.6-9.6V46H105.11V61.22A9.6,9.6,0,0,0,114.72,70.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.44,46V61.22a9.6,9.6,0,0,1-9.6,9.6h-1.12a9.6,9.6,0,0,1-9.61-9.6V46h20.33m0-1H105.11a1,1,0,0,0-1,1V61.22a10.65,10.65,0,0,0,10.64,10.63h1.12a10.64,10.64,0,0,0,10.63-10.63V46a1,1,0,0,0-1-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.43,61.58a11.87,11.87,0,0,1-1.41-.09.86.86,0,0,1-.65-.43c-.75-1.25,1-6,1.53-7.44a.51.51,0,0,1,.66-.3.52.52,0,0,1,.3.67c-1.14,3-1.86,5.87-1.63,6.49a12.44,12.44,0,0,0,2.58,0,.51.51,0,0,1,.57.45.5.5,0,0,1-.45.57A11,11,0,0,1,115.43,61.58Zm-1.18-1h0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,47.29S125,53.17,122.63,52s-3.6-4.4-7.73-4.48c-3.58-.06-5.63,5.15-8.61,4.4a6.17,6.17,0,0,1-4-3.57A16,16,0,0,1,117,41.48C127.13,42.23,128.92,47.29,128.92,47.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.29,52.66a1.93,1.93,0,0,1-.9-.22,10,10,0,0,1-2.3-1.81c-1.32-1.26-2.69-2.56-5.2-2.61-1.55,0-2.87,1.15-4.14,2.28s-2.81,2.55-4.58,2.1a6.64,6.64,0,0,1-4.38-3.89.55.55,0,0,1,0-.45A16.6,16.6,0,0,1,117,41c10.38.76,12.32,5.93,12.39,6.15a.5.5,0,0,1-.05.46C129,48.15,125.86,52.66,123.29,52.66ZM114.83,47h.08c2.92,0,4.5,1.56,5.89,2.9a9.21,9.21,0,0,0,2.06,1.63c1.35.69,4-2.17,5.47-4.28-.5-1-3-4.63-11.39-5.24a15.62,15.62,0,0,0-14.08,6.38,5.61,5.61,0,0,0,3.56,3c1.23.31,2.35-.7,3.64-1.86S112.89,47,114.83,47Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,48.33a38.36,38.36,0,0,1,1-8.93c1.08-4,9.3-6.82,13.59-6.08s10.18,4,11,5.93,1,8,1,8S112.37,38.62,102.27,48.33Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,48.85a.65.65,0,0,1-.19,0,.52.52,0,0,1-.32-.47,38.71,38.71,0,0,1,1-9.07c1.18-4.4,9.7-7.24,14.18-6.46s10.47,4.08,11.42,6.23,1.05,8,1.05,8.24a.5.5,0,0,1-.24.45.54.54,0,0,1-.51,0c-.16-.09-16.34-8.39-26.05,1A.49.49,0,0,1,102.27,48.85Zm13.12-15.13c-4.19,0-10.71,2.44-11.61,5.81a34.84,34.84,0,0,0-1,7.63c9-7.48,22.22-2.22,25.56-.7-.07-1.73-.31-5.6-.93-7-.75-1.69-6.39-4.89-10.66-5.63A8.52,8.52,0,0,0,115.39,33.72Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,67.8a9,9,0,0,1-4.07-1.18.51.51,0,0,1-.22-.69.52.52,0,0,1,.7-.22c1.89,1,3.5,1.28,4.79.87a3.1,3.1,0,0,0,1.8-1.4.52.52,0,0,1,.7-.22.51.51,0,0,1,.23.68,4.2,4.2,0,0,1-2.39,1.92A4.91,4.91,0,0,1,116,67.8Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.63,
    cy: 52.89,
    rx: 0.58,
    ry: 1.33,
    transform: "translate(-3.23 8) rotate(-3.78)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.07,
    cy: 53.51,
    rx: 0.58,
    ry: 1.33,
    transform: "translate(-3.29 7.44) rotate(-3.78)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.59,122.68h-8.9a.5.5,0,0,1-.5-.5V109.89a.5.5,0,0,1,.5-.5h8.9a.5.5,0,0,1,.5.5v12.29A.51.51,0,0,1,118.59,122.68Zm-8.41-1h7.91V110.39h-7.91Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.21,97.91c-.15-.09-13.56,28.5-21.7,29.77s-12.12-5-8.54-12S168,96.33,168,96.33l15.49-5.72Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.49,128.35a8.24,8.24,0,0,1-7-3.16c-1.83-2.54-1.83-6.17,0-9.72,3.59-7,16.62-19,17.18-19.52a.5.5,0,0,1,.17-.11l15.49-5.71a.51.51,0,0,1,.54.11.52.52,0,0,1,.13.53l-2.31,7.29a.54.54,0,0,1-.11.18c-.09.16-.39.75-.73,1.42-9.31,18.18-16.47,27.78-21.28,28.53A14.08,14.08,0,0,1,157.49,128.35Zm10.82-31.57c-1.08,1-13.52,12.64-16.88,19.16-1.65,3.2-1.68,6.43-.08,8.65s4.52,3.13,8.08,2.58c3.07-.48,9.12-5.72,20.52-28,.43-.85.65-1.27.79-1.5l2-6.23Zm12.9,1.13h0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.42 107.29 146.26 107.29 159.06 72.99 186.22 72.99 173.42 107.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,107.8H146.26a.51.51,0,0,1-.48-.69l12.8-34.3a.51.51,0,0,1,.48-.34h27.16a.5.5,0,0,1,.42.22.51.51,0,0,1,.06.48l-12.8,34.3A.52.52,0,0,1,173.42,107.8Zm-26.42-1h26.06L185.48,73.5H159.42Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66,100.89c.15-.44,5.52-9.25,5.2-12.26-.23-2.2-8.6-6.11-10.39-5.79s3.58,3.9,3.58,3.9-8.22-3.59-8.74-1.48,7.79,4.22,7.79,4.22-8.85-1.58-9.06.21,7.27,2.84,7.27,2.84-6.95-.42-5.79,1.16,8.59,3.74,8.59,3.74",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.65,101.4a.39.39,0,0,1-.18,0,.5.5,0,0,1-.3-.64,10.41,10.41,0,0,1,.55-1c1.2-2.15,4.87-8.69,4.63-11,0-.15-.17-.7-1.5-1.7-2.6-2-6.87-3.66-8.13-3.66h0a17.72,17.72,0,0,0,3.62,3,.52.52,0,0,1,.17.67.51.51,0,0,1-.66.23c-2.45-1.06-6.75-2.54-7.9-2-.11.06-.13.11-.14.16-.24,1,3.72,2.65,7.42,3.59a.51.51,0,0,1,.38.61.52.52,0,0,1-.6.4c-4.51-.81-8.25-.79-8.46-.24s3.25,1.77,6.83,2.27a.53.53,0,0,1,.45.57.51.51,0,0,1-.55.46c-2.42-.15-4.8,0-5.33.34.93,1.11,5.55,2.75,8.3,3.55a.52.52,0,0,1-.29,1c-.78-.23-7.63-2.26-8.86-3.93a.93.93,0,0,1-.12-1c.23-.43.93-.69,1.82-.83-1.84-.56-3.4-1.37-3.27-2.49a1.13,1.13,0,0,1,.46-.77c.71-.52,2.36-.6,4.08-.51-1.94-.85-3.58-2-3.26-3.21a1.26,1.26,0,0,1,.69-.84c1.07-.53,3.35,0,5.35.66-.93-.84-1.34-1.51-1.24-2a.84.84,0,0,1,.77-.66c1.61-.28,6.64,2,9.09,3.83,1.21.91,1.83,1.7,1.91,2.42.24,2.34-2.42,7.44-4.76,11.62-.26.46-.44.78-.48.88A.55.55,0,0,1,179.65,101.4Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.36 71.96 166.59 76.7 177.45 76.38 179.19 71.96 168.36 71.96",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59,77.2a.49.49,0,0,1-.4-.21.51.51,0,0,1-.07-.46l1.77-4.75a.5.5,0,0,1,.47-.32h10.83a.5.5,0,0,1,.46.68l-1.74,4.43a.49.49,0,0,1-.45.31l-10.86.32Zm2.11-4.74-1.39,3.72,9.79-.28,1.36-3.44Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.37,72.79a2.31,2.31,0,0,0,0-1.33,2.15,2.15,0,0,0-1.66-1.36,2.85,2.85,0,0,0-2.12.55,2.93,2.93,0,0,0-1.17,1.71,2.34,2.34,0,0,0,2,2.83A3.13,3.13,0,0,0,176.37,72.79Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,75.7h-.18a2.63,2.63,0,0,1-1.94-1.08,3,3,0,0,1-.53-2.36,3.53,3.53,0,0,1,1.37-2,3.38,3.38,0,0,1,2.5-.63,2.63,2.63,0,0,1,2,1.69,2.82,2.82,0,0,1,0,1.61h0A3.74,3.74,0,0,1,173.56,75.7Zm.72-5.14a2.44,2.44,0,0,0-1.42.49,2.47,2.47,0,0,0-1,1.42,1.92,1.92,0,0,0,.36,1.54,1.62,1.62,0,0,0,1.21.69,2.65,2.65,0,0,0,2.44-2h0a1.87,1.87,0,0,0,0-1,1.65,1.65,0,0,0-1.27-1A1.84,1.84,0,0,0,174.28,70.56Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.62,137.62s-4.4-7.15-10.77-6.93c-4.39.16-10.94,3.4-10.94,3.4L81.72,164.3s9.61,7.34,11.14,5,2.45-4.68,1.55-6.2-6-4.2-6-4.2l-.63-6.11s-3.57,1.27-4.71.63S73.62,137.62,73.62,137.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87,170.31c-3,0-9.68-5-10.46-5.6L51.54,134.45a.51.51,0,0,1-.14-.45.54.54,0,0,1,.28-.38c.27-.13,6.7-3.29,11.15-3.44h.32c6.41,0,10.73,6.88,10.91,7.18l0,0c3.92,7.17,8.5,15.1,9.27,15.66.64.35,2.88-.18,4.27-.68a.54.54,0,0,1,.45.05.51.51,0,0,1,.24.38l.61,5.84c1.12.6,5.09,2.8,5.94,4.27,1.13,1.93-.23,4.74-1.57,6.75a1.56,1.56,0,0,1-1.05.64A2.22,2.22,0,0,1,91.87,170.31ZM52.79,134.24l29.3,29.69c2,1.57,7.94,5.67,10,5.33a.52.52,0,0,0,.36-.19c1.66-2.5,2.21-4.51,1.54-5.66s-4.4-3.28-5.78-4a.52.52,0,0,1-.27-.4l-.57-5.47c-1.18.37-3.47,1-4.51.39-1.19-.65-7.69-12.43-9.66-16-.19-.3-4.44-6.86-10.31-6.67C59.43,131.33,54.53,133.44,52.79,134.24Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,234.74H87.68a.46.46,0,1,1,0-.92H98a.46.46,0,0,1,0,.92Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,234.74H122.71a.46.46,0,0,1,0-.92H133a.46.46,0,0,1,0,.92Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.51,
    cy: 38.88,
    r: 2.61,
    fill: "#ff663b",
    className: "target-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogisticsFlatline);
export default __webpack_public_path__ + "static/media/logistics-flatline.8d278f14555007be72bea2380bb58181.svg";
export { ForwardRef as ReactComponent };